/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCaptureLabelRequest
 */
export interface UpdateCaptureLabelRequest {
    /**
     * 
     */
    labelId: string;
    /**
     * 
     */
    category?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    description?: string | null;
}

/**
 * Check if a given object implements the UpdateCaptureLabelRequest interface.
 */
export function instanceOfUpdateCaptureLabelRequest(value: object): value is UpdateCaptureLabelRequest {
    if ((!('labelId' in (value as Record<string, any>)) && !('label_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['labelId'] === undefined && (value as Record<string, any>)['label_id'] === undefined)) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpdateCaptureLabelRequestFromJSON(json: any): UpdateCaptureLabelRequest {
    return UpdateCaptureLabelRequestFromJSONTyped(json, false);
}

export function UpdateCaptureLabelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCaptureLabelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'labelId': json['label_id'],
        'category': json['category'] == null ? undefined : json['category'],
        'name': json['name'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
    };
}

export function UpdateCaptureLabelRequestToJSON(json: any): UpdateCaptureLabelRequest {
    return UpdateCaptureLabelRequestToJSONTyped(json, false);
}

export function UpdateCaptureLabelRequestToJSONTyped(value?: UpdateCaptureLabelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label_id': value['labelId'],
        'category': value['category'],
        'name': value['name'],
        'description': value['description'],
    };
}

